import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDay,
  getTillAmount,
  RESET_DAYSTART,
  selectDayEndSuccess,
  selectTillAmount,
} from "../../redux/features/dayStart/DayStartSlice";
import { selectPendingOrders } from "../../redux/features/order/OrderSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DayEnd = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [closingBalance, setClosingBalance] = useState(0);
  const pendingOrders = useSelector(selectPendingOrders);
  const tillAmount = useSelector(selectTillAmount);
  const isSuccess = useSelector(selectDayEndSuccess);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCloseDay = async (closingBalance) => {
    await dispatch(
      closeDay({ closingBalance: closingBalance ? closingBalance : 0 })
    );
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(getTillAmount());
      dispatch(RESET_DAYSTART());
      navigate("/reports");
      setIsOpen(false);
    }
  }, [isSuccess, dispatch, navigate]);
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  return (
    <>
      <button
        onClick={() => {
          if (pendingOrders.length > 0) {
            toast.error("Please Complete the pending Orders");
          } else {
            setIsOpen(!isOpen);
          }
        }}
        className=" uppercase bg-[#A9A9A9] text-nowrap md:text-[.9rem] text-[.7rem] md:rounded-xl rounded-lg text-white font-semibold md:px-5 px-3  py-2 "
      >
        Day End
      </button>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] sm:w-[450px] w-[90%] mx-auto p-8 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                Day End
              </h1>
              <button type="button" onClick={() => setIsOpen(!isOpen)}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>

            {/* <div className="mb-6 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Closing Balance
              </label>
              <input
                value={closingBalance}
                onChange={(e) => setClosingBalance(e.target.value)}
                min={0}
                step={1}
                onWheel={(e) => e.target.blur()}
                type="number"
                placeholder="1000,2000 etc."
                className={`w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] `}
              />
            </div> */}
            <div className="text-[#0D868C] text-[1.2rem] font-medium">
              Are you sure you want to end the day? Your closing balance is{" "}
              {priceSymbol}: {tillAmount}
            </div>

            <div className="text-center mt-8">
              <button
                onClick={() => handleCloseDay(closingBalance)}
                className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
              >
                Day End
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DayEnd;
